import React, { useState, useEffect } from "react";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { 
    Box, Button, Container, TextField, Grid, 
    MenuItem, Card, CardContent, 
    Typography, Divider, CardHeader,
    Table, TableBody, TableCell, TableContainer, 
    TableHead, TableRow, Paper, IconButton, Chip,
    Checkbox, Dialog, DialogTitle, DialogContent, DialogActions,
    TablePagination, InputAdornment, FormControlLabel
} from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CasinoIcon from '@mui/icons-material/Casino';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

// --- DATA SẢNH GAME NỔ HŨ (RNG) ---
const PROVIDERS_RNG = [
    { id: "140", name: "JILI" }, { id: "141", name: "FC" },
    { id: "39", name: "PP" }, { id: "16", name: "CQ9" },
    { id: "55", name: "JDB" }, { id: "43", name: "MG" },
    { id: "111", name: "PT" }, { id: "79", name: "BBIN" },
    { id: "40", name: "PGS" }, { id: "22", name: "TP" },
    { id: "23", name: "FG" }, { id: "34", name: "KA" },
    { id: "399", name: "DG Slot" }, { id: "47", name: "MW" },
    { id: "49", name: "PS" }, { id: "555", name: "SW" },
    { id: "56", name: "GPS" }, { id: "59", name: "SG" },
    { id: "61", name: "CG" }, { id: "65", name: "GM" },
    { id: "68", name: "GD" }
];

// Định dạng "Trị" CSS ngoại lai: Đổ nền trắng cho Label để che viền
const inputStyles = {
    mb: 3, 
    "& .MuiOutlinedInput-root": {
        backgroundColor: "#fff",
        borderRadius: "8px",
    },
    "& .MuiInputLabel-root": {
        backgroundColor: "#ffffff !important", // Đổ nền trắng cho Label
        padding: "0 8px !important",
        marginLeft: "-4px",
        color: "#555",
        zIndex: 1, // Đẩy Label lên trên vạch viền
    },
    "& .MuiInputLabel-root.Mui-focused": {
        color: "#ff9800 !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        borderColor: "#ff9800 !important",
    }
};

function ThemGameNoHu() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    // State Form (Thêm trường hot)
    const [addFormData, setAddFormData] = useState({
        gameType: "RNG", providerId: "", tcgGameCode: "", gameName: "", img: "", apiCodeOverride: "", status: 1, hot: 0
    });

    const [editFormData, setEditFormData] = useState({});
    const [editPopupOpen, setEditPopupOpen] = useState(false);
    const [editId, setEditId] = useState(null);

    // State Dữ liệu
    const [gameList, setGameList] = useState([]);
    const [loading, setLoading] = useState(false);

    // State Lọc, Tìm kiếm & Phân trang
    const [searchTerm, setSearchTerm] = useState("");
    const [filterProvider, setFilterProvider] = useState("all");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        fetchGames();
    }, []);

    const fetchGames = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/casino/subgames`);
            if (res.data && res.data.data) {
                setGameList(res.data.data);
            }
        } catch (error) {
            console.error("Lỗi lấy danh sách:", error);
        }
    };

    const isApiSuccess = (res) => {
        if (!res || !res.data) return false;
        if (res.data.status === false || res.data.status === 0 || res.data.success === false) return false;
        return true;
    };

    const getGameId = (game) => game._id || game.id;

    // --- CÁC HÀM XỬ LÝ DỮ LIỆU ---
    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setAddFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        if (!addFormData.providerId || !addFormData.tcgGameCode || !addFormData.gameName || !addFormData.img) {
            swal("Thiếu thông tin", "Vui lòng điền đủ thông tin bắt buộc!", "warning");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/casino/subgames`, addFormData);
            if (isApiSuccess(response)) {
                swal("Thành công", response.data.message || "Đã thêm game mới!", "success");
                setAddFormData({ ...addFormData, tcgGameCode: "", gameName: "", img: "", apiCodeOverride: "", hot: 0 }); 
                fetchGames(); 
            } else {
                swal("Lỗi", response.data.message || "Thêm game thất bại!", "error");
            }
        } catch (error) {
            swal("Lỗi", error.response?.data?.message || "Không thể kết nối máy chủ", "error");
        } finally {
            setLoading(false);
        }
    };

    const openEditPopup = (game) => {
        const id = getGameId(game);
        if (!id) return swal("Lỗi", "Không tìm thấy ID của game này", "error");
        setEditId(id);
        setEditFormData({
            providerId: game.providerId, tcgGameCode: game.tcgGameCode, gameName: game.gameName,
            img: game.img, apiCodeOverride: game.apiCodeOverride || "", status: Number(game.status) || 0, hot: Number(game.hot) || 0
        });
        setEditPopupOpen(true);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEditSubmit = async () => {
        setLoading(true);
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/casino/subgames/${editId}`, editFormData);
            if (isApiSuccess(response)) {
                swal("Thành công", "Cập nhật game thành công!", "success");
                setEditPopupOpen(false);
                fetchGames();
            } else {
                swal("Lỗi", response.data.message || "Cập nhật thất bại!", "error");
            }
        } catch (error) {
            swal("Lỗi", "Không thể kết nối máy chủ", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleToggleStatus = async (game) => {
        const id = getGameId(game);
        if (!id) return;
        const newStatus = Number(game.status) === 1 ? 0 : 1;
        setGameList(prev => prev.map(g => getGameId(g) === id ? { ...g, status: newStatus } : g));

        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/casino/subgames/${id}`, { status: newStatus });
            if (!isApiSuccess(res)) {
                swal("Lỗi", "Không thể cập nhật trạng thái", "error");
                fetchGames(); 
            }
        } catch (error) {
            swal("Lỗi", "Lỗi máy chủ", "error");
            fetchGames(); 
        }
    };

    // Hàm cập nhật trạng thái HOT
    const handleToggleHot = async (game) => {
        const id = getGameId(game);
        if (!id) return;
        const newHot = Number(game.hot) === 1 ? 0 : 1;
        setGameList(prev => prev.map(g => getGameId(g) === id ? { ...g, hot: newHot } : g));

        try {
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/casino/subgames/${id}`, { hot: newHot });
            if (!isApiSuccess(res)) {
                swal("Lỗi", "Không thể cập nhật trạng thái HOT", "error");
                fetchGames(); 
            }
        } catch (error) {
            swal("Lỗi", "Lỗi máy chủ", "error");
            fetchGames(); 
        }
    };

    const handleDelete = async (game) => {
        const id = getGameId(game);
        if (!id) return;

        swal({
            title: "Bạn chắc chắn muốn xóa?",
            text: `Bạn đang xóa game: ${game.gameName}`,
            icon: "warning",
            buttons: ["Hủy", "Xóa vĩnh viễn"],
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                try {
                    const res = await axios.delete(`${process.env.REACT_APP_API_URL}/casino/subgames/${id}`);
                    if (isApiSuccess(res)) {
                        swal("Thành công", "Đã xóa game!", "success");
                        fetchGames();
                    } else {
                        swal("Lỗi", res.data.message || "Không thể xóa!", "error");
                    }
                } catch (error) {
                    swal("Lỗi", "Lỗi máy chủ", "error");
                }
            }
        });
    };

    const getProviderName = (id) => {
        const prov = PROVIDERS_RNG.find(p => p.id === id);
        return prov ? prov.name : id;
    };

    // --- LOGIC LỌC TÌM KIẾM & PHÂN TRANG ---
    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredGames = gameList.filter((game) => {
        const matchProvider = filterProvider === "all" || game.providerId === filterProvider;
        const matchSearch = game.gameName.toLowerCase().includes(searchTerm.toLowerCase()) || 
                            game.tcgGameCode.toLowerCase().includes(searchTerm.toLowerCase());
        return matchProvider && matchSearch;
    });

    const displayedGames = filteredGames.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: "#f4f6f8", minHeight: "100vh" }}>
                    <Container maxWidth="lg">
                        
                        <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold", color: "#121828" }}>
                            Quản Lý Game Con (Nổ Hũ)
                        </Typography>

                        {/* ================================== */}
                        {/* FORM THÊM MỚI GAME                 */}
                        {/* ================================== */}
                        <Card sx={{ boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)", borderRadius: "16px", mb: 4 }}>
                            <CardHeader 
                                title="Thêm Game Nổ Hũ Mới" 
                                subheader="Cấu hình game Slot để hiển thị ra ngoài trang chủ"
                                avatar={<CasinoIcon sx={{ color: "#ff9800", fontSize: 40 }} />}
                                sx={{ borderBottom: "1px solid #edf2f7", pb: 2 }}
                            />
                            <CardContent sx={{ p: 4 }}>
                                <form onSubmit={handleAddSubmit}>
                                    <Grid container spacing={6}>
                                        <Grid item xs={12} md={6}>
                                            <TextField select fullWidth label="Chọn Sảnh Nổ Hũ (Provider) *" name="providerId" value={addFormData.providerId} onChange={handleAddChange} sx={inputStyles} InputLabelProps={{ shrink: true }}>
                                                {PROVIDERS_RNG.map(prov => (
                                                    <MenuItem key={prov.id} value={prov.id}>{prov.name} (ID: {prov.id})</MenuItem>
                                                ))}
                                            </TextField>
                                            <TextField fullWidth label="Mã Game (Game Code API) *" name="tcgGameCode" value={addFormData.tcgGameCode} onChange={handleAddChange} sx={inputStyles} InputLabelProps={{ shrink: true }} helperText="Ví dụ: 49, vs20olympgate, 103..." />
                                            <TextField fullWidth label="Mã API Ghi Đè (apiCodeOverride)" name="apiCodeOverride" value={addFormData.apiCodeOverride} onChange={handleAddChange} sx={inputStyles} InputLabelProps={{ shrink: true }} helperText="Chỉ dùng khi sảnh yêu cầu mã riêng. Để trống nếu không cần." />
                                            
                                            {/* CHECKBOX HOT BÊN FORM THÊM */}
                                            <FormControlLabel
                                                control={
                                                    <Checkbox 
                                                        checked={addFormData.hot === 1} 
                                                        onChange={(e) => setAddFormData(prev => ({ ...prev, hot: e.target.checked ? 1 : 0 }))} 
                                                        color="warning" 
                                                    />
                                                }
                                                label={<Typography sx={{ fontWeight: "bold", color: "#ff9800" }}>Đánh dấu là Game HOT (Bật lửa)</Typography>}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField fullWidth label="Tên Game Hiển Thị *" name="gameName" value={addFormData.gameName} onChange={handleAddChange} sx={inputStyles} InputLabelProps={{ shrink: true }} />
                                            <TextField fullWidth label="Link Ảnh (Image URL) *" name="img" value={addFormData.img} onChange={handleAddChange} sx={inputStyles} InputLabelProps={{ shrink: true }} />
                                            
                                            <Box sx={{ mt: -1.5, p: 2, border: "1px dashed #c4c4c4", borderRadius: 2, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "115px", backgroundColor: "#fafafa" }}>
                                                {addFormData.img ? (
                                                    <img src={addFormData.img} alt="Preview" style={{ maxWidth: "100%", maxHeight: "120px", objectFit: "contain", borderRadius: "8px" }} onError={(e) => { e.target.onerror = null; e.target.src = "https://via.placeholder.com/300x200?text=Lỗi+Load+Ảnh" }} />
                                                ) : (
                                                    <><PhotoCameraIcon sx={{ color: "#ccc", fontSize: 30 }} /><Typography variant="body2" color="textSecondary">Xem trước hình ảnh</Typography></>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Divider sx={{ my: 3 }} />
                                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                        <Button type="submit" variant="contained" disabled={loading} sx={{ minWidth: 200, py: 1.5, fontWeight: "bold", fontSize: "15px", backgroundColor: "#ff9800", "&:hover": { backgroundColor: "#e68a00" } }}>
                                            {loading ? "ĐANG XỬ LÝ..." : "THÊM GAME NỔ HŨ"}
                                        </Button>
                                    </Box>
                                </form>
                            </CardContent>
                        </Card>

                        {/* ================================== */}
                        {/* THANH CÔNG CỤ TÌM KIẾM & LỌC       */}
                        {/* ================================== */}
                        <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                            <TextField
                                select
                                label="Lọc theo sảnh"
                                value={filterProvider}
                                onChange={(e) => { setFilterProvider(e.target.value); setPage(0); }}
                                sx={{ minWidth: 200, ...inputStyles, mb: 0 }}
                                InputLabelProps={{ shrink: true }}
                            >
                                <MenuItem value="all">Tất cả sảnh</MenuItem>
                                {PROVIDERS_RNG.map(prov => (
                                    <MenuItem key={prov.id} value={prov.id}>{prov.name}</MenuItem>
                                ))}
                            </TextField>
                            
                            <TextField
                                label="Tìm tên hoặc mã game..."
                                value={searchTerm}
                                onChange={(e) => { setSearchTerm(e.target.value); setPage(0); }}
                                sx={{ flexGrow: 1, ...inputStyles, mb: 0 }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>

                        {/* ================================== */}
                        {/* BẢNG DANH SÁCH GAME CÓ PHÂN TRANG  */}
                        {/* ================================== */}
                        <TableContainer component={Paper} sx={{ borderRadius: "16px", boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)" }}>
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead sx={{ backgroundColor: "#f4f6f8" }}>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: "bold", width: "100px" }}>Hình ảnh</TableCell>
                                        <TableCell sx={{ fontWeight: "bold" }}>Tên Game</TableCell>
                                        <TableCell sx={{ fontWeight: "bold" }}>Sảnh</TableCell>
                                        <TableCell sx={{ fontWeight: "bold" }}>Mã Game</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", align: "center" }}>HOT</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", align: "center" }}>Trạng thái</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", align: "center" }}>Hành động</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {displayedGames.length > 0 ? (
                                        displayedGames.map((game) => (
                                            <TableRow key={getGameId(game)} sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: '#f9f9f9' } }}>
                                                <TableCell>
                                                    <img src={game.img} alt="game" style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "8px", border: "1px solid #eee" }} />
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "600" }}>{game.gameName}</TableCell>
                                                <TableCell>
                                                    <Chip label={getProviderName(game.providerId)} size="small" sx={{ backgroundColor: "#e3f2fd", color: "#1976d2", fontWeight: "bold" }} />
                                                </TableCell>
                                                <TableCell>
                                                    {game.tcgGameCode}
                                                    {game.apiCodeOverride && <Typography variant="caption" display="block" color="textSecondary">({game.apiCodeOverride})</Typography>}
                                                </TableCell>
                                                
                                                {/* CỘT TICK HOT */}
                                                <TableCell align="center">
                                                    <Checkbox 
                                                        checked={Number(game.hot) === 1} 
                                                        onChange={() => handleToggleHot(game)} 
                                                        color="warning"
                                                    />
                                                </TableCell>

                                                {/* CỘT BẬT / TẮT (STATUS) */}
                                                <TableCell align="center">
                                                    <Checkbox 
                                                        checked={Number(game.status) === 1} 
                                                        onChange={() => handleToggleStatus(game)} 
                                                        color="success"
                                                    />
                                                </TableCell>

                                                <TableCell align="center">
                                                    <IconButton color="primary" onClick={() => openEditPopup(game)} title="Sửa">
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton color="error" onClick={() => handleDelete(game)} title="Xóa">
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center" sx={{ py: 5, color: "#888" }}>
                                                Không tìm thấy game nào!
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                component="div"
                                count={filteredGames.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Số dòng mỗi trang:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} trong tổng số ${count}`}
                            />
                        </TableContainer>

                        {/* ================================== */}
                        {/* POPUP CHỈNH SỬA (DIALOG)           */}
                        {/* ================================== */}
                        <Dialog open={editPopupOpen} onClose={() => setEditPopupOpen(false)} maxWidth="md" fullWidth>
                            <DialogTitle sx={{ fontWeight: "bold", borderBottom: "1px solid #eee", backgroundColor: "#f9f9f9" }}>
                                Chỉnh Sửa Dữ Liệu Game
                            </DialogTitle>
                            <DialogContent sx={{ mt: 3 }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                        <TextField select fullWidth label="Sảnh Nổ Hũ *" name="providerId" value={editFormData.providerId || ""} onChange={handleEditChange} InputLabelProps={{ shrink: true }} sx={inputStyles}>
                                            {PROVIDERS_RNG.map(prov => (
                                                <MenuItem key={prov.id} value={prov.id}>{prov.name}</MenuItem>
                                            ))}
                                        </TextField>
                                        <TextField fullWidth label="Mã Game *" name="tcgGameCode" value={editFormData.tcgGameCode || ""} onChange={handleEditChange} InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                        <TextField fullWidth label="Mã Ghi Đè" name="apiCodeOverride" value={editFormData.apiCodeOverride || ""} onChange={handleEditChange} InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                        
                                        {/* CHECKBOX HOT BÊN FORM SỬA */}
                                        <FormControlLabel
                                            control={
                                                <Checkbox 
                                                    checked={editFormData.hot === 1} 
                                                    onChange={(e) => setEditFormData(prev => ({ ...prev, hot: e.target.checked ? 1 : 0 }))} 
                                                    color="warning" 
                                                />
                                            }
                                            label={<Typography sx={{ fontWeight: "bold", color: "#ff9800" }}>Đánh dấu là Game HOT (Bật lửa)</Typography>}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Tên Game *" name="gameName" value={editFormData.gameName || ""} onChange={handleEditChange} InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                        <TextField fullWidth label="Link Ảnh *" name="img" value={editFormData.img || ""} onChange={handleEditChange} InputLabelProps={{ shrink: true }} sx={inputStyles} />
                                        
                                        <Box sx={{ mt: -2, p: 1, border: "1px dashed #c4c4c4", borderRadius: 2, textAlign: "center", minHeight: "100px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fafafa" }}>
                                            {editFormData.img ? (
                                                <img src={editFormData.img} alt="Preview" style={{ maxHeight: "110px", borderRadius: "8px", objectFit: "contain" }} />
                                            ) : (
                                                <Typography variant="body2" color="textSecondary">Chưa có ảnh</Typography>
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions sx={{ p: 3, pt: 0 }}>
                                <Button onClick={() => setEditPopupOpen(false)} color="inherit" variant="outlined" sx={{ fontWeight: "bold" }}>Hủy Bỏ</Button>
                                <Button onClick={handleEditSubmit} variant="contained" disabled={loading} sx={{ backgroundColor: "#2196f3", fontWeight: "bold" }}>
                                    {loading ? "Đang lưu..." : "Xác Nhận Cập Nhật"}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default ThemGameNoHu;




